__turbopack_context__.v({
  "footer": "SignIn-module-scss-module__qgkJwW__footer",
  "form": "SignIn-module-scss-module__qgkJwW__form",
  "form__field": "SignIn-module-scss-module__qgkJwW__form__field",
  "link": "SignIn-module-scss-module__qgkJwW__link",
  "support": "SignIn-module-scss-module__qgkJwW__support",
});
